/* eslint-disable react-hooks/exhaustive-deps */
import { ApiKeyFetch } from 'api/fetchers/apiKey';
import { urlValidarPantallaPago } from 'constants/urls';
import { useAccionesPantallaPago } from 'contexts/FormPagoContext';
import useCustomRouter from 'hooks/useCustomRouter';
import useQueryParams from 'hooks/useQueryParams';
import useUsuario from 'hooks/useUsuario';
import React, { useEffect, useState } from 'react';
import Loading from 'wrappers/Loading';

const withValidarPago = (Component) => (props) => {
  const queryParams = useQueryParams();
  const router = useCustomRouter();
  const [loading, setLoading] = useState(true);
  const usuario = useUsuario();

  const accionesPago = useAccionesPantallaPago();

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    const from = queryParams?.from || 'default';
    const tokenCorreo = queryParams?.tokenCorreo;
    const sessionId = queryParams?.sessionId;
    const idPoliza = queryParams?.idPoliza;
    const codProducto = queryParams?.codProducto;

    const body = {
      idPoliza,
      codProducto,
      tokenCorreo,
      sessionId,
      from,
    };

    if (usuario?.userIsLoggedIn) {
      body['cliCodigoCore'] = usuario.cliCodigoCore;
      body['correo'] = usuario.correo;
    }

    const response = await ApiKeyFetch.instance().post(urlValidarPantallaPago, body);

    //1. es link de cobro
    const showFormPago =
      (from !== 'default' && response?.isValidSession) ||
      (from === 'default' &&
        response?.permiteContinuar === true &&
        response?.tieneTokenActivo !== true);

    const showFormCancelarTokens = from === 'default' && response?.tieneTokenActivo === true;

    const isFromLinkCobro =
      typeof from === 'string' &&
      from !== 'default' &&
      typeof tokenCorreo === 'string' &&
      typeof sessionId === 'string';

    accionesPago.setState({
      permiteContinuar: response?.permiteContinuar === true,
      tieneTokenActivo: response?.tieneTokenActivo === true,
      idPoliza,
      codProducto,
      tokenCorreo,
      sessionId,
      from,
      isFromLinkCobro,
      showFormPago: showFormPago,
      showFormCancelarTokens: showFormCancelarTokens,
    });

    if (response?.errorCode) {
      return router.push(`/error-page/${response?.errorCode}`);
    }

    setLoading(false);
  };

  return (
    <React.Fragment>
      <Loading loading={loading}>
        <Component {...props} />
      </Loading>
    </React.Fragment>
  );
};

export default withValidarPago;
